import { notification } from 'antd';

export function openNotification(message, placement = 'topRight', duration = 1.5) {
  notification.success({
    message,
    placement,
    duration,
  });
}
